module.exports = __webpack_public_path__ + "static/media/balloons.495932af.png";